export enum AnueCmsAds {
  CNYES_CLUB = 'Home_RightSide_D',
  RIGHT_SIDE_BANNER = 'RightSide-Banner-B',
  FLOATING_AD_ID = 'News_float_btn',
};
